import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DuplicateCopyIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.03613 6C3.03613 4.34315 4.37928 3 6.03613 3H14.0361C15.693 3 17.0361 4.34315 17.0361 6V7H18.0361C19.693 7 21.0361 8.34315 21.0361 10V18C21.0361 19.6569 19.693 21 18.0361 21H10.0361C8.37928 21 7.03613 19.6569 7.03613 18V17H6.03613C4.37928 17 3.03613 15.6569 3.03613 14V6ZM9.03613 18C9.03613 18.5523 9.48385 19 10.0361 19H18.0361C18.5884 19 19.0361 18.5523 19.0361 18V10C19.0361 9.44772 18.5884 9 18.0361 9H10.0361C9.48385 9 9.03613 9.44772 9.03613 10V18ZM15.0361 7H10.0361C8.37928 7 7.03613 8.34315 7.03613 10V15H6.03613C5.48385 15 5.03613 14.5523 5.03613 14V6C5.03613 5.44772 5.48385 5 6.03613 5H14.0361C14.5884 5 15.0361 5.44772 15.0361 6V7Z"
            />
        </SvgIcon>
    );
};

export default DuplicateCopyIcon;
